export default __webpack_public_path__ + "static/media/m_engineering_card26_1.3a64e8e9.png";